import { Fragment, useEffect, useRef } from "react";
import LoadingPrimary from "../../assets/animations/loading_primary.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAuth from "../../hooks/use_auth";

const Landing = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const { loginFromAdmin, loadings } = useAuth();

  const calledRef = useRef(false);

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      navigate("/login");
      return;
    }

    // prevent double call
    if (calledRef.current) return;

    calledRef.current = true;

    loginFromAdmin(token);
  }, [searchParams, navigate]);

  return (
    <Fragment>
      {loadings.loginFromAdmin && (
        <div className="layout_loading">
          <img src={LoadingPrimary} alt="Loading..." />
        </div>
      )}
    </Fragment>
  );
};

export default Landing;
